// extracted by mini-css-extract-plugin
export default {"btn":"hlHzUKll2CZI1wc_xuL8","btnInactive":"GSR5J1quyLbVk1Ghfrtd"};